<template>
    <div>
        <vue-headful title="Vacature plaatsen" />
        <Header page_title="Vacature plaatsen" />
        <div class="container-fluid app-body">
            <form @submit.prevent="onSubmit">
                <div class="step-question">
                    <button type="submit" ref="submit" hidden>submit</button>
                    <div ref="step">
                        <template v-if="step === 1">
                            <register-steps :steps="{1:'Locatie',2:'Datum',3:'Vacature informatie', 4:'Geplaatst'}" totalAnswered="50" currentStep="1" />
                            <strong class="sd-title mini right-line">
                                <span class="title-text">
                                    <svg-icon icon="marker" /> Locatie
                                </span>
                            </strong>
                            <div class="form">
                                <ul class="list-unstyled">
                                    <li v-for="item in locationList" v-bind:key="item.id">
                                        <div class="custom-control custom-radio">
                                            <input
                                                type="radio"
                                                class="custom-control-input"
                                                v-model="form.address_id"
                                                :value="item.id"
                                                v-bind:id="`location-` + item.id"
                                            />
                                            <label
                                                class="custom-control-label text-uppercase"
                                                v-bind:for="`location-` + item.id"
                                            >
                                                <span class="d-block" v-if="item.name_location">
                                                    <span class="d-inline-block mr-1">
                                                        {{ item.name_location }}
                                                    </span>
                                                </span>
                                                <span class="d-block">
                                                    <span class="d-inline-block mr-1">
                                                        {{ item.street }}
                                                    </span>
                                                    {{ item.street_number }} {{ item.house_addition }}
                                                </span>
                                                <span class="d-block">
                                                    <span class="d-inline-block mr-2">
                                                        {{ item.postal_code }}
                                                    </span>
                                                    {{ item.city }}
                                                </span>
                                            </label>
                                        </div>
                                    </li>
                                    <li v-if="Object.keys(locationList).length > 0">
                                        <router-link
                                            :to="{ path: '/company/location/add' }"
                                            title="Add Location"
                                            class="btn btn-add btn-block position-relative"
                                        >
                                            <div class="icon-wrapper position-absolute">
                                                <i class="material-icons">add_circle</i>
                                            </div>
                                            Voeg nieuwe locatie toe
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </template>

                        <template v-if="step === 2">
                            <register-steps :steps="{1:'Locatie',2:'Datum',3:'Vacature informatie', 4:'Geplaatst'}" totalAnswered="50" currentStep="2" />
                            <div class="sd-title medium" style="margin-bottom: 20px;">
                                <strong class="sd-title mini right-line">
                                <span class="title-text">
                                    <svg-icon icon="calendar" /> {{ questions[1].display }}
                                </span>
                                </strong>
                            </div>
                            <div class="sd-form">
                                <div class="input-row">
                                    <div class="sd-input sd-col-6 form-group date-style">
                                        <label for="start_date">Gewenste startdatum</label>
                                        <keep-alive>
                                            <v-date-picker
                                                locale="nl"
                                                mode="date"
                                                v-model="form.start_date"
                                                ref="calendarInstance"
                                                :min-date="new Date()"
                                                :max-date="new Date(new Date().setMonth(new Date().getMonth() + 6))"
                                            ></v-date-picker>
                                        </keep-alive>
                                    </div>

                                    <div class="sd-input sd-col-6 form-group date-style">
                                        <label for="end_date">Verwachte einddatum</label>
                                        <keep-alive>
                                            <v-date-picker
                                                locale="nl"
                                                mode="date"
                                                v-model="form.end_date"
                                                ref="calendarInstance"
                                                :min-date="new Date()"
                                                :max-date="new Date(new Date().setMonth(new Date().getMonth() + 12))"
                                            ></v-date-picker>
                                        </keep-alive>
                                    </div>
                                    <span class="extra-info sd-col-12" style="margin-top: -10px;">
                                        <svg-icon icon="information"/>
                                        Ter info: wanneer de startdatum is verstreken, wordt deze automatisch verplaatst zodat de vacature actief blijft.
                                    </span>
                                </div>

                                <div class="input-row">
                                    <!-- Hours per week -->
                                    <div class="sd-col-12 sd-input form-group date-style">
                                        <label for="hoursPerWeek">(Geschat) aantal uur per week</label>
                                        <input
                                            type="number"
                                            id="hoursPerWeek"
                                            v-model="form.periods"
                                            min="0"
                                            placeholder="Bijvoorbeeld: 16"
                                            class="form-control"
                                            required
                                        />
                                    </div>
                                </div>

                                <!-- Shifts -->
                                <div class="form-group custom-days-list">
                                    <label><b>Diensten</b></label>
                                    <div class="form-group days-select">
                                        <div class="custom-control custom-checkbox custom-control-inline">
                                            <input
                                                type="checkbox"
                                                id="Day"
                                                value="day"
                                                class="custom-control-input"
                                                v-model="form.healthcareDates"
                                            />
                                            <label class="custom-control-label" for="Day">Dag</label>
                                        </div>
                                        <div class="custom-control custom-checkbox custom-control-inline">
                                            <input
                                                type="checkbox"
                                                id="Evening"
                                                value="evening"
                                                class="custom-control-input"
                                                v-model="form.healthcareDates"
                                            />
                                            <label class="custom-control-label" for="Evening">Avond</label>
                                        </div>
                                        <div class="custom-control custom-checkbox custom-control-inline">
                                            <input
                                                type="checkbox"
                                                id="Night"
                                                value="night"
                                                class="custom-control-input"
                                                v-model="form.healthcareDates"
                                            />
                                            <label class="custom-control-label" for="Night">Nacht</label>
                                        </div>
                                        <div class="custom-control custom-checkbox custom-control-inline">
                                            <input
                                                type="checkbox"
                                                id="Weekend"
                                                value="weekend"
                                                class="custom-control-input"
                                                v-model="form.healthcareDates"
                                            />
                                            <label class="custom-control-label" for="Weekend">Weekend</label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Own transport -->
                            <div class="form-group custom-days-list">
                                <label><b>Vervoer</b></label>
                                <div>
                                    <div class="custom-control custom-checkbox custom-control-inline">
                                        <input
                                            type="checkbox"
                                            id="OwnTransport"
                                            value="hasTransport"
                                            v-model="form.healthcareDates"
                                            class="custom-control-input"
                                        />
                                        <label for="OwnTransport" class="custom-control-label">De zorgmedewerker heeft eigen vervoer nodig</label>
                                    </div>
                                </div>
                            </div>
                        </template>

                        <template v-if="step === 3 && questions[2] && answers[2]">
                            <register-steps :steps="{1:'Locatie',2:'Datum',3:'Vacature informatie', 4:'Geplaatst'}" totalAnswered="33" currentStep="3" />
                            <div class="sd-title medium" style="margin-bottom: 20px; display: flex; align-items: center;">
                                <span class="steps">1/4</span>
                                <div>
                                    {{ questions[2].display }}
                                </div>
                            </div>
                            <div class="form">
                                <ul id="functions" class="list-unstyled">
                                    <li v-for="item in answers[2]" v-bind:key="item.id">
                                        <div class="custom-control custom-checkbox">
                                            <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                v-model="form.user_answers[questions[2].id]['answer_id'][item.id]"
                                                :value="item.id"
                                                v-bind:id="`functions-` + item.id"
                                            />
                                            <label
                                                class="custom-control-label"
                                                v-bind:for="`functions-` + item.id"
                                            >{{ item.answer }}</label>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </template>

                        <template v-if="step === 4 && questions[3] && answers[3]">
                            <register-steps :steps="{1:'Locatie',2:'Datum',3:'Vacature informatie', 4:'Geplaatst'}" totalAnswered="66" currentStep="3" />
                            <div class="sd-title medium" style="margin-bottom: 20px;">
                                <span class="steps">2/4</span>
                                {{ questions[3].display }}
                            </div>
                            <div class="form">
                                <ul id="target" class="list-unstyled">
                                    <li v-for="item in answers[3]" v-bind:key="item.id">
                                        <div class="custom-control custom-checkbox">
                                            <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                v-model="form.user_answers[questions[3].id]['answer_id'][item.id]"
                                                :value="item.id"
                                                v-bind:id="`target-` + item.id"
                                            />
                                            <label
                                                class="custom-control-label"
                                                v-bind:for="`target-` + item.id"
                                            >{{ item.answer }}</label>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </template>

                        <template v-if="step === 5 && questions[4] && answers[4]">
                            <register-steps :steps="{1:'Locatie',2:'Datum',3:'Vacature informatie', 4:'Geplaatst'}" totalAnswered="99" currentStep="3" />

                            <div class="sd-title medium step-container">
                                <span class="steps">3/4</span>
                                {{ questions[4].display }}
                            </div>

                            <div class="form pt-2" v-if="form.user_answers[questions[4].id]">
                                <div
                                    v-for="(items, groupName) in groupedAnswersStep5"
                                    :key="groupName"
                                    class="subcategory-group"
                                >
                                    <h5 class="subcategory-header">{{ groupName }}</h5>

                                    <li v-for="item in items" :key="item.id" style="list-style: none">
                                        <div class="custom-control custom-checkbox">
                                            <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                v-model="form.user_answers[questions[4].id]['answer_id'][item.id]"
                                                :value="item.id"
                                                :id="`functions-` + item.id"
                                            />
                                            <label
                                                class="custom-control-label"
                                                :for="`functions-` + item.id"
                                            >{{ item.answer }}</label>
                                        </div>
                                    </li>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
                <template>
                    <div hidden>
                        <v-stepper ref="stepper" :steps="steps" :linear="false" v-model="step"></v-stepper>
                    </div>
                </template>
            </form>
        </div>
        <div class="step next-btn">
            <template>
                <div class="px-4 mx-2">
                    <button
                        v-if="step < steps"
                        type="button"
                        title="Volgende"
                        class="btn btn-warning btn-block"
                        @click="nextStep"
                    >Volgende</button>
                    <!-- @click="$refs.stepper.next()" -->
                    <button
                        v-if="step === steps"
                        type="button"
                        title="Volgende"
                        class="btn btn-warning btn-block"
                        @click="triggerSubmit"
                    >Volgende</button>
                    <!-- v-on:click="done = true" -->
                </div>
            </template>
        </div>
        <div v-if="done" class="fullscreen-notif position-fixed">
            <div class="d-flex min-height align-items-center">
                <div class="container-fluid px-4 mx-2">
                    <div class="text-center pb-1">
                        <div class="icon svg mb-4 pb-1">
                            <svg
                                viewBox="0 0 122 106"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <g transform="translate(3.000000, 3.000000)">
                                        <g stroke="#625A55" stroke-width="4.2">
                                            <path
                                                d="M-1.77635684e-15,100 C-1.77635684e-15,80.1827237 21.0048161,64.1176471 46.9155699,64.1176471 C72.8263237,64.1176471 93.8311398,80.1827237 93.8311398,100 L-1.77635684e-15,100 Z"
                                            />
                                            <ellipse
                                                cx="46.9155699"
                                                cy="31.7647059"
                                                rx="31.6680097"
                                                ry="31.7647059"
                                                fill="#FFCD00"
                                            />
                                            <path
                                                d="M95.8086962,17.4085625 L108.95566,71.234468"
                                                fill="#D8D8D8"
                                                fill-rule="nonzero"
                                                stroke-linecap="round"
                                                transform="translate(102.382178, 44.321515) rotate(45.000000) translate(-102.382178, -44.321515) "
                                            />
                                            <polyline points="28.7357866 66.4705882 46.9155699 80 64.5089086 66.4705882" />
                                        </g>
                                        <g
                                            transform="translate(38.000000, 29.000000)"
                                            fill="#625A55"
                                            fill-rule="nonzero"
                                        >
                                            <circle cx="4" cy="4" r="4"  center=""/>
                                            <circle cx="26" cy="4" r="4"  center=""/>
                                        </g>
                                        <path
                                            d="M42.1844298,46.3411731 C47.8510965,51.6352907 53.5177632,52.7252561 59.1844298,49.6110692"
                                            stroke="#625A55"
                                            stroke-width="4"
                                            stroke-linecap="round"
                                            transform="translate(50.684430, 48.841173) rotate(-8.000000) translate(-50.684430, -48.841173) "
                                        />
                                    </g>
                                </g>
                            </svg>
                        </div>
                        <div class="sd-title large text-uppercase bold text-white text-center mb-4">Gelukt!</div>
                        <div
                            class="heading-20-500"
                        >De vacature is geplaatst. Bekijk matches en sollicitaties via het dashboard.</div>
                    </div>
                </div>

                <div class="footer-btn">
                    <div class="container-fluid px-4 mx-2">
                        <router-link
                            :to="{ name: 'company-dashboard' }"
                            title="Bekijk"
                            class="btn btn-light btn-block"
                            v-ripple="'rgba(192, 189, 187, 0.35)'"
                        >Naar het dashboard</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {VStepper} from "vue-stepper-component";

export default {
    components: {
        VStepper
    },
    data: function() {
        let steps = 5;

        return {
            branch: localStorage.getItem("branch"),
            steps: steps,
            step: 1,
            done: null,
            shifts: ['Dag', 'Avond', 'Nacht', 'Weekend', 'Ik ben flexibel'],
            questions: {},
            questions_array: {},
            answers_array: {},
            answers: {},
            locationList: [],
            fetchPromise: null,
            old_start_date: null,
            old_end_date: null,
            form: {
                start_date: null,
                end_date: null,
                periods: "",
                address_id: "",
                description: "",
                subject: "",
                user_answers: {},
                title: '',
                healthcareDates: [],
            },
        };
    },
    async created() {},
    async mounted() {
        await this.fetchData();
    },

    watch: {
        $route: "fetchData",


        'form.user_answers': {
            immediate: false,
            deep: true,
            handler() {
                this.syncQ4WithQ3();
            }
        },
    },

    computed: {
        groupedAnswersStep5() {
            if (this.step !== 5) return {};

            let q4List = [];
            try {
                q4List = this.answers[4] || [];

                // Step 3 selection logic
                const q3 = this.questions[3];
                if (!q3 || q3.id === undefined) return {};

                const selectionMap =
                    (this.form.user_answers[q3.id] &&
                        this.form.user_answers[q3.id].answer_id) ||
                    {};

                const selectedNames = new Set();
                (this.answers[3] || []).forEach(ans => {
                    if (selectionMap[ans.id]) {
                        selectedNames.add(ans.answer);
                    }
                });

                // If no selection → return all
                const filtered =
                    selectedNames.size === 0
                        ? q4List
                        : q4List.filter(item => {
                            const subName =
                                item.sub_category ||
                                item.subcategory ||
                                item.subCategory;
                            return subName && selectedNames.has(subName);
                        });

                // Group results
                const groups = {};
                filtered.forEach(item => {
                    const group = item.sub_category || "Overig";
                    if (!groups[group]) groups[group] = [];
                    groups[group].push(item);
                });

                return groups;
            } catch (e) {
                // Fallback grouping
                const groups = {};
                (this.answers[4] || []).forEach(item => {
                    const group = item.sub_category || "Overig";
                    if (!groups[group]) groups[group] = [];
                    groups[group].push(item);
                });
                return groups;
            }
        }
    },

    methods: {
        async fetchData() {
            // Prevent parallel fetch bursts (which can cause 429s)
            if (this.fetchPromise) return this.fetchPromise;
            this.$store.state.loading = true;
            this.fetchPromise = (async () => {
                // Memoization: skip refetch if already loaded
                const hasQuestions = this.questions_array && this.questions_array[1] && this.questions_array[2] && this.questions_array[3] && this.questions_array[4];
                if (!hasQuestions) {
                    await this.getQuestions();
                }
                const hasAnswers = this.answers_array && this.answers_array[2] && this.answers_array[3] && this.answers_array[4];
                if (!hasAnswers) {
                    await this.getAnswers();
                }
                await this.getLocationsList();

                // Initialize boolean-map answer objects for checkbox groups (questions 2,3,4)
                await this.fillFormJob();

                await this.autoFillForm();
                this.$forceUpdate();
            })()
            .catch(err => {
                console.error(err);
            })
            .finally(() => {
                this.$store.state.loading = false;
                this.fetchPromise = null;
            });
            return this.fetchPromise;
        },

        async buildTheTitle() {
            let titleAnswers = [];

            for (let i = 0; i < this.answers[3].length; i++) {
                const answerObj = this.answers[3][i];

                if (this.answers_array[3][answerObj.id] === true) {
                    titleAnswers.push(answerObj.answer);
                }
            }

            const location = this.locationList.find(l => l.id === this.form.address_id);
            this.form.title = location.city + ', ' + titleAnswers.join(', ');
        },

        async autoFillForm() {
            return new Promise(resolve => {
                if (localStorage.getItem("job")) {
                    const job = JSON.parse(localStorage.getItem("job"));
                    // map job keys to their answers/question index
                    const mapping = {
                        qualification: 2,
                        group: 3,
                        specialization: 4
                    };

                    for (const obj in job) {
                        if (obj === "id") {
                            this.form[obj] = job[obj]; // ID
                        } else if (mapping[obj] !== undefined) {
                            const questionIndex = mapping[obj];

                            // make sure the user_answers structure exists
                            if (!this.form.user_answers[this.questions[questionIndex].id]) {
                                this.form.user_answers[this.questions[questionIndex].id] = { answer_id: {} };
                            }

                            // loop through each value in job[obj] array
                            for (const value of job[obj]) {
                                // find the matching answer object
                                const answer = this.answers[questionIndex].find(a => a.answer === value);
                                if (answer) {
                                    this.form.user_answers[this.questions[questionIndex].id].answer_id[answer.id] = true;
                                }
                            }
                        } else if (obj === 'start_date' || obj === 'end_date') {
                            if (obj === 'start_date') {
                                if(new Date(job[obj]) < new Date()) {
                                    this.form[obj] = new Date();
                                } else {
                                    this.form[obj] = new Date(job[obj]);
                                }
                                this.old_start_date = job[obj];
                            } else {
                                this.form[obj] = new Date(job[obj]);
                                this.old_end_date = job[obj];
                            }
                        } else if (obj === "healthcare_availability") {
                            let saved = JSON.parse(job[obj]);
                            this.form.healthcareDates = Object.keys(saved).filter(key => saved[key] === true);
                        }
                        else {
                            if (this.form.hasOwnProperty(obj)) {
                                this.form[obj] = job[obj]; // update
                            }
                        }
                    }

                    localStorage.setItem("form-pending", JSON.stringify(true));
                }

                // Normalize stored user_answers to boolean-map format for checkbox groups (questions 2,3,4)
                [2,3,4].forEach(idx => this.ensureBooleanMapForIndex(idx));

                resolve();
            });
        },

        async getLocationsList() {
            let promises = [];
            promises.push(
                new Promise(resolve => {
                    let user = JSON.parse(localStorage.getItem("user"));
                    this.locationList = user.addresses;
                    resolve();
                })
            );
            return Promise.all(promises);
        },

        // Initialize boolean-map user_answers like Applicant candidate logic
        async fillFormJob() {
            return new Promise(resolve => {
                [2,3,4].forEach(questionNumber => {
                    const question_id = this.questions_array[questionNumber];
                    if (!question_id) return;
                    if (!this.form.user_answers[question_id] || !this.form.user_answers[question_id].answer_id) {
                        this.$set(this.form.user_answers, question_id, { answer_id: this.answers_array[questionNumber] || {} });
                    }
                });
                resolve();
            });
        },

        // Ensure any legacy/alternative shapes are converted to boolean-map under answer_id
        ensureBooleanMapForIndex(index) {
            if (!this.questions[index] || this.questions[index].id === undefined) return;
            const qId = this.questions[index].id;
            const answersMap = this.answers_array[index] || {};
            const existing = this.form.user_answers[qId];

            // If already proper shape, ensure all keys exist
            if (existing && existing.answer_id && typeof existing.answer_id === 'object') {
                // Ensure every possible answer id exists as a boolean
                Object.keys(answersMap).forEach(aid => {
                    if (existing.answer_id[aid] === undefined) {
                        this.$set(existing.answer_id, aid, false);
                    }
                });
                return;
            }

            // If it was an array of selected ids
            if (Array.isArray(existing)) {
                const newMap = {};
                Object.keys(answersMap).forEach(aid => newMap[aid] = false);
                existing.forEach(id => {
                    const key = String(id);
                    newMap[key] = true;
                });
                this.$set(this.form.user_answers, qId, { answer_id: newMap });
                return;
            }

            // If it was an object map of id => boolean (without answer_id wrapper)
            if (existing && typeof existing === 'object') {
                const newMap = {};
                Object.keys(answersMap).forEach(aid => newMap[aid] = false);
                Object.keys(existing).forEach(aid => {
                    if (existing[aid]) newMap[aid] = true;
                });
                this.$set(this.form.user_answers, qId, { answer_id: newMap });
                return;
            }

            // Otherwise initialize fresh
            this.$set(this.form.user_answers, qId, { answer_id: { ...answersMap } });
        },

        // Keep Q4 selections in sync with Q3 selection and available filtered answers
        syncQ4WithQ3() {
            if (!this.questions[3] || !this.questions[4]) return;
            const q3id = this.questions[3].id;
            const q4id = this.questions[4].id;
            if (q3id === undefined || q4id === undefined) return;

            // Ensure boolean maps exist
            this.ensureBooleanMapForIndex(3);
            this.ensureBooleanMapForIndex(4);

            const allowedIds = new Set((this.groupedAnswersStep5 || []).map(a => a.id));
            const q4map = (this.form.user_answers[q4id] && this.form.user_answers[q4id].answer_id) || {};
            Object.keys(q4map).forEach(id => {
                const idNum = Number(id);
                const ok = allowedIds.has(id) || (!Number.isNaN(idNum) && allowedIds.has(idNum));
                if (q4map[id] && !ok) {
                    this.$set(this.form.user_answers[q4id].answer_id, id, false);
                }
            });
        },

        formatDate(date) {
            return date.toLocaleDateString("en-CA");
        },

        // Helper: sleep for ms
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },

        // Helper: GET with retry/backoff to mitigate 429/5xx
        async httpGetWithRetry(config, retries = 2, baseDelay = 400) {
            let attempt = 0;
            while (true) {
                try {
                    return await this.$http(config);
                } catch (err) {
                    const status = err && err.response && err.response.status;
                    const shouldRetry = (status === 429 || (status >= 500 && status < 600)) && attempt < retries;
                    if (!shouldRetry) throw err;
                    const delay = baseDelay * Math.pow(2, attempt); // exponential backoff
                    await this.sleep(delay);
                    attempt++;
                }
            }
        },

        // get questions
        async getQuestions() {
            const q_url = this.$apiURI + "/question/job/3/";
            for (let question_number = 1; question_number <= 4; question_number++) {
                try {
                    const result = await this.httpGetWithRetry({ method: "GET", url: q_url + question_number });
                    const q_id = result.data.data[0].id;
                    const q_number = result.data.data[0].number;
                    this.$set(this.questions, q_number, {
                        id: result.data.data[0].id,
                        display: result.data.data[0].display
                    });
                    this.$set(this.questions_array, q_number, q_id);
                } catch (error) {
                    console.error(error);
                    // Stop further requests on hard failure
                    break;
                }
            }
        },

        //assign answers
        async getAnswers() {
            const a_url = this.$apiURI + "/answers/3/";
            const arr = {
                qualification: 2,
                group: 3,
                specialization: 4,
            };

            // Fetch sequentially to avoid burst and apply retry/backoff
            for (const itemKey of Object.keys(arr)) {
                try {
                    const result = await this.httpGetWithRetry({ method: "GET", url: a_url + itemKey });
                    this.$set(
                        this.answers,
                        arr[itemKey], // number
                        result.data.data
                    );

                    const answerIds = {};
                    for (const v in result.data.data) {
                        answerIds[result.data.data[v].id] = false;
                    }
                    this.$set(this.answers_array, arr[itemKey], answerIds);
                } catch (error) {
                    console.error(error);
                    break;
                }
            }
        },

        triggerSubmit() {
            const elem = this.$refs.submit;
            elem.click();
        },

        formatToYMD(dateInput) {
            const d = new Date(dateInput);
            if (isNaN(d)) return null; // invalid date

            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');

            return `${year}-${month}-${day}`;
        },

        async onSubmit() {
            await this.buildTheTitle();

            const old_start_date = this.old_start_date ? this.formatToYMD(this.old_start_date) : null;
            const old_end_date = this.old_end_date ? this.formatToYMD(this.old_end_date) : null;
            const start_date = this.formatToYMD(this.form.start_date);
            const end_date = this.formatToYMD(this.form.end_date);

            if (old_start_date && old_start_date === start_date) {
            } else {
                this.form.start_date = new Date(this.form.start_date.getTime() + 24 * 60 * 60 * 1000);
            }

            if (old_end_date && old_end_date === end_date) {
            } else {
                this.form.end_date = new Date(this.form.end_date.getTime() + 24 * 60 * 60 * 1000);
            }

            const next = this.validateForm();
            if (next) {
                localStorage.setItem("job", JSON.stringify(this.form));
                localStorage.removeItem("form-pending");
                await this.$router.replace({name: "job_step-2-healthcare"});
            }
        },


        nextStep() {
            const next = this.validateForm();
            window.scrollTo(0, 0);
            if (next) {
                this.$refs.stepper.next();
            }
        },

        validateForm() {
            let $checkradios = $('input[type="radio"]:visible');
            let $input = $('input[required="required"]:visible');
            let $checkboxes = $('input:not(.selection)[type="checkbox"]:visible');
            let $timestamps = $('.timestamp');

            if ($checkradios.length) {
                let checkedRadios = $('input[type="radio"]:visible:checked').length;
                if (!checkedRadios) {
                    alert("Graag een antwoord selecteren.");
                    return false;
                }
            }

            if ($input.length) {
                // check if all inputs have values
                let emptyInputs = $('input[required="required"]:invalid').length;
                if (emptyInputs) {
                    alert("Graag het formulier volledig invullen.");
                    return false;
                }
            }

            if ($checkboxes.length) {
                let checkedCheckboxes = $('input[type="checkbox"]:visible:checked').length;
                if (!checkedCheckboxes) {
                    alert("Graag een antwoord selecteren.");
                    return false;
                }
            }

            if (this.step === 2) {
                if (this.form.periods !== null && this.form.periods !== undefined) {
                    if (this.form.periods === '') {
                        alert("Graag het aantal uren per shift invullen.");
                        return false;
                    }

                    const hours = Number(this.form.periods);
                    if (isNaN(hours)) {
                        alert("Het aantal uren per shift moet een geldig getal zijn.");
                        return false;
                    }

                    if (hours <= 0) {
                        alert("Het aantal uren per shift moet groter zijn dan 0.");
                        return false;
                    } else if (hours > 24) {
                        alert("Het aantal uren per shift mag niet groter zijn dan 24.");
                        return false;
                    }
                }

                if (!this.form.start_date) {
                    alert("Graag een startdatum selecteren.");
                    return false;
                }

                if (!this.form.end_date) {
                    alert("Graag een einddatum selecteren.");
                    return false;
                }

                if (new Date(this.form.end_date) <= new Date(this.form.start_date)) {
                    alert("De einddatum moet na de startdatum liggen.");
                    return false;
                }

                if ($timestamps.length) {
                    let startHours = [];
                    $('.starthour').each(function (val) {
                        startHours.push(val.value);
                    });

                    let startMinutes = [];
                    $('.startminute').each(function (val) {
                        let minutesAsDecimal = "00";
                        if (val.value === "15")
                            minutesAsDecimal = "25";
                        else if (val.value === "30")
                            minutesAsDecimal = "50";
                        else if (val.value === "45")
                            minutesAsDecimal = "75";
                        startMinutes.push(minutesAsDecimal);
                    });

                    let endHours = [];
                    $('.endhour').each(function (val) {
                        endHours.push(val.value);
                    });

                    let endMinutes = [];
                    $('.endminute').each(function (val) {
                        let minutesAsDecimal = "00";
                        if (val.value === "15")
                            minutesAsDecimal = "25";
                        else if (val.value === "30")
                            minutesAsDecimal = "50";
                        else if (val.value === "45")
                            minutesAsDecimal = "75";
                        endMinutes.push(minutesAsDecimal);
                    });

                    let startTimes = [];
                    for (let i = 0; i < startHours.length; i++) {
                        startTimes[i] = startHours[i] + "" + startMinutes[i];
                    }

                    let endTimes = [];
                    for (let i = 0; i < endHours.length; i++) {
                        endTimes[i] = endHours[i] + "" + endMinutes[i];
                    }

                    for (let i = 0; i < startTimes.length; i++) {
                        if (startTimes[i] >= endTimes[i]) {
                            alert("Begintijden kunnen niet na de eindtijden zijn");
                            return false;
                        } else if (endTimes[i] - startTimes[i] < 300) {
                            alert("Een dag kan niet korter zijn dan 3 uur");
                            return false;
                        }
                    }
                }
            }
            return true;
        },
    },

    ready() {
        this.$forceUpdate();
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from;
        });
    },

    beforeRouteLeave(to, from, next) {
        // remove the form-pending if accessing the subpage
        const subpages = ["job_step-2-healthcare"];
        if (subpages.indexOf(to.name) > -1) {
            next();
        } else {
            this.savePending(to, from, next);
        }
    }
};
</script>

<style scoped>
form.showing-calendar {
    margin-bottom: 320px;
}
.form-group.w-square-icon input.calendar {
    padding-right: 0;
}
.form-group.w-square-icon .calendar i[class*="material-icon"] {
    border: none;
}

.extra-info.collapsable {
    margin-bottom: 20px;
    background-color: #fff9e2;
    border-radius: 5px;
    flex-direction: column;
    align-items: flex-start;
    padding: 10px;
    user-select: none;
}

.extra-info.collapsable .extra-info-title {
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;
    width: 100%;
}

.extra-info.collapsable .extra-info-title .expand {
    position: absolute;
    right: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.extra-info.collapsable .extra-info-title .expand::before,
.extra-info.collapsable .extra-info-title .expand::after {
    content: '';
    position: absolute;
    display: block;
    width: 2px;
    height: 10px;
    background-color: #64513D;
    transform: rotateZ(90deg);
    transition: .3s ease-in-out;
}

.extra-info.collapsable .extra-info-title:not(.open) .expand::after {
    transform: rotateZ(0deg);
}

.fullscreen-notif .icon.svg svg {
    right: -22px;
}
.syncfusion-calendar > input {
    position: absolute;
    opacity: 0;
}

.quick-select .custom-checkbox .custom-control-label::before {
    display: none;
}
.quick-select .custom-checkbox .custom-control-label::after {
    display: none;
}

.step-question .custom-days-list .custom-checkbox .custom-control-label {
    padding-left: 16px;
}

.step-question .custom-days-list .custom-checkbox .custom-control-label::before,
.step-question .custom-days-list .custom-checkbox .custom-control-label::after {
    display: none;
}

.step-question .custom-days-list .custom-control-input:checked ~ .custom-control-label {
    background-color: #FFCD00;
    border-color: #FFCD00;
}

.step-question .date-style {
    display: flex;
    flex-direction: column;
}

.step-question .date-style input {
    background-color: #FFF;
    border: 1px solid #64513D;
    border-radius: 10px;
}

/deep/.step-question .date-style input.vc-appearance-none.vc-text-base.vc-text-gray-800.vc-bg-white.vc-border.vc-border-gray-400.vc-rounded.vc-w-full.vc-py-2.vc-px-3 {
    height: 50px;
    background-color: #FFF;
    border: 1px solid #64513D;
    border-radius: 10px;
    color: #64513D;
    font: 14px / 50px "Real Head Pro", sans-serif;
    font-weight: 200;
}

.quick-select .custom-control {
    padding-left: 0;
    margin-right: 15px;
    cursor: pointer;
}

.step-question .custom-control {
    margin-bottom: 15px;
}

.step-question .quick-select .custom-control label {
    background-color: #FFF;
    border: 2px solid #F6F6F6;
    border-radius: 5px;
    padding: 7px 15px;
    color: #64513D;
    font-weight: 200;
    margin-bottom: 15px;
    font-size: 14px;
    line-height: 1;
}

.step-question .quick-select .custom-control input:checked + label {
    border: 2px solid #FFCD00;
    background-color: #FFCD00;
    color: #FFF;
}

.step-question .quick-select .custom-control {
    background: none;
    font-size: 16px;
    margin-bottom: 0;
}

ul.audience-list li:first-child {
    display: none;
}

.step-question .list-unstyled {
    margin: 20px 0 0;
}

.step-question ol li {
    padding: 20px;
}

.step-question ol li:nth-child(odd) {
    background-color: #f6f6f6;
    border-radius: 10px;
}

.step-question ol li strong {
    margin-bottom: 5px;
    display: block;
}

.input-group .custom-select,
.grid-item .form-control {
    border-radius: 10px !important;
    height: 35px;
    padding: 0 10px;
}

.grid-item label {
    margin-bottom: 0;
}

.display-grid {
    display: grid;
    grid-template-columns: 1fr 20px 1fr;
}

.display-grid strong {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
}

.w-square-icon {
    position: relative;
}

.input-group .w-square-icon .icon-wrapper {
    width: 30px;
    height: 35px;
    pointer-events: none;
}

.input-group/deep/ .w-square-icon .icon-wrapper svg {
    width: 10px;
}

.grid-time-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 30px;
    row-gap: 10px;
}

.grid-time-container .grid-item.long {
    grid-column: span 2;
}

.grid-time-container .grid-item.clockhours span {
    display: block;
    margin-top: 12px;
}

.container-fluid.popup-container {
    position: fixed;
    top: 40px;
    z-index: 101;
    padding-left: 0;
    padding-right: 60px;
    animation: slide .5s forwards, slide-back .5s forwards 2.5s;
}

.container-fluid.popup-container .popup {
    width: 100%;
    border: 1px solid #44B24C;
    background-color: #bafbe6;
    color: #64513D;
    font-weight: 500;
    border-radius: 15px;
    padding: 10px 30px;
}

.subcategory-group {
    display: flex;
    flex-wrap: wrap;
    column-gap: 10px;
}

.subcategory-group li {
    width: 45%;
}

.subcategory-header {
    width: 100%;
    font-weight: bold;
    margin-top: 30px;
    margin-bottom: 10px;
}

@keyframes slide {
    0% {
        transform: translateY(40%);
        opacity: 0;
    }
    100% {
        transform: translateY(0%);
        opacity: 1;
    }
}

@keyframes slide-back {
    0% {
        transform: translateY(0%);
        opacity: 1;
    }
    100% {
        transform: translateY(40%);
        opacity: 0;
    }
}
</style>

